import React from 'react';

import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

import { PricingHeader } from '../components/pricing/PricingHeader';
import { PricingPlans } from '../components/pricing/PricingPlans';
import { AdditionalChargesSection } from '../components/pricing/sections/AdditionalChargesSection';

export function PricingPage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <PricingHeader />
          <PricingPlans />
          <AdditionalChargesSection />
        </div>
      </div>
      <Footer />
    </>
  );
}